module.exports = __webpack_public_path__ + "img/mobile-phone.4ee13cf5.jpg";